import type { DataAvailabilityStatus } from "../types";

/** Whether a metric status represents an observed value that may be displayed. */
export function metricHasValue(status?: DataAvailabilityStatus): boolean {
  return (
    !status ||
    status === "available" ||
    status === "measured_zero" ||
    status === "partial"
  );
}

/** Apply the shared N/A contract without changing valid measured-zero values. */
export function valueOrUnavailable(
  formattedValue: string,
  status?: DataAvailabilityStatus,
): string {
  return metricHasValue(status) ? formattedValue : "N/A";
}

/** Comparisons are unavailable when the underlying metric was not collected. */
export function comparisonOrUnavailable(
  formattedValue: string,
  status?: DataAvailabilityStatus,
): string {
  return metricHasValue(status) ? formattedValue : "—";
}
